import Vue from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const onClose =()=> {
    console.log('onClose');
}

const options = {
    timeout: 15000,
    closeOnClick: false,
    position: 'bottom-right',
    onClose: onClose
};

Vue.use(Toast, options);